import { DropdownOption } from 'components/final-form/dropdownUtils';
import React from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid } from 'semantic-ui-react';
import { Field } from 'react-final-form';
import CheckBox from 'components/final-form/CheckBox';
import Select from 'components/final-form/Select';
import { required } from 'utils/validatorUtils';
import styled from 'styled-components';
import PraxFormLabelSpan from 'components/layout/PraxFormLabelSpan';
import PxGrid from 'components/layout/PxGrid';
import PraxFormGrid from 'components/layout/PraxFormGrid';

interface Props extends MessageSourceProps {
  treaters: Array<DropdownOption>,
  subCostCenters: Array<DropdownOption>,
  reasonForEncounters: Array<DropdownOption>
  emergencies: Array<DropdownOption>
}

const StyledBorderGridRow = styled(Grid.Row)`
     border-bottom: 1px solid rgba(34,36,38,.1);
`;

const TreaterAndInfoSegment = (props: Props): React.ReactNode => {

  const {getMessage, treaters, subCostCenters, reasonForEncounters, emergencies} = props;

  return (
      <PraxFormGrid>
        <StyledBorderGridRow>
        </StyledBorderGridRow>
        <Grid.Row>
          <Grid.Column width={5} verticalAlign={"middle"}>
            <PraxFormLabelSpan>{`${getMessage("treatment.info.treater")}:`}</PraxFormLabelSpan>
            <Field
                name="treaterId"
                component={Select}
                options={treaters}
                validate={required}
                fluid
            />
          </Grid.Column>
          <Grid.Column width={5} verticalAlign={"middle"}>
            <PraxFormLabelSpan>{`${getMessage("consultation.subCostCenter")}:`}</PraxFormLabelSpan>
            <Field
                name="subCostCenterId"
                component={Select}
                options={subCostCenters}
                validate={required}
                fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={10} verticalAlign={"middle"}>
            <PraxFormLabelSpan>{`${getMessage("consultation.rfe")}:`}</PraxFormLabelSpan>
            <Field
                name="reasonForEncounterId"
                component={Select}
                options={reasonForEncounters}
                clearable
                fluid
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={5} verticalAlign={"middle"}>
            <PraxFormLabelSpan>{`${getMessage("consultation.emergency")}:`}</PraxFormLabelSpan>
            <Field
                name="emergencyType"
                component={Select}
                options={emergencies}
                fluid
            />
          </Grid.Column>
          <Grid.Column width={2} verticalAlign={"bottom"}>
            <Field
                name="bmiIndex"
                component={CheckBox}
                label={getMessage("consultation.bmi")}
            />
          </Grid.Column>
        </Grid.Row>
      </PraxFormGrid>
  )
};

export default withMessages(TreaterAndInfoSegment);
